import React from 'react';

let context = React.createContext({});

let AuthSessionProvider = context.Provider;
let AuthSessionConsumer = context.Consumer;

export {AuthSessionProvider, AuthSessionConsumer};